import {Component} from 'react';
import {FormError} from './form-errors';
import {RadioBox} from './radiobox';
import {getMonthText} from './lib/utils';
class  MontantsDetailles extends Component{
	constructor (props){
		super(props);
		this.state={
			continuation:true,
		};
		this.state.montants = [];
		var date  = new Date();
		var [year , month] = [date.getFullYear() , date.getMonth()+1];
		this.thisMonth =  `${year}-${month.toString().padStart(2, "0")}`;

		for  (var i =0 ; i<3 ; i++ ){
			month -= 1;
			if (month == 0 ){
				year -=1 ;
				month = 12;
			}
			let dateString = year + '-' + ('0' + month.toString()).slice(-2);
			this.state.montants[dateString]='';
		}
		this.state.totalYear='';

		this.changeMontant = this.changeMontant.bind(this);
		this.changeMontantTotal = this.changeMontantTotal.bind(this);
	}
	
	distributeMontants = ()=>{
		const montantTotal  = this.state.totalYear;
		

				// Obtenez les noms des mois dans un tableau
		const months = Object.keys(this.state.montants);

		// Triez les noms des mois par ordre décroissant en fonction de leur index dans le tableau des mois
		const sortedMonths = months.sort((a, b) => new Date(b) - new Date(a));

		// Prenez les trois premiers mois dans la liste triée
		const lastThreeMonths = sortedMonths.slice(0, 3);

		// Calculez la somme des montants pour les trois derniers mois
		const sumLastThreeMonths = lastThreeMonths.reduce((sum, currentMonth) => {
		    return sum + this.state.montants[currentMonth];
		}, 0);
		const reste = (montantTotal-sumLastThreeMonths ) / 9;

		var data = {

		};
		var date = new Date();
		var month = ((12+(date.getMonth()-4))%12)+1;
		var year  = ( date.getMonth()-3 ) > 0 ? parseInt(date.getFullYear()) : parseInt(date.getFullYear())-1;


		for (let j = 0; j < 45; j++) {
		    let dateString = year + '-' + ('0' + month.toString()).slice(-2);
		    data[dateString] = j < 9 ? parseInt(reste) : montantTotal / 12;

		    month -= 1;
		    if (month === 0) {
		        year -= 1;
		        month = 12;
		    }
		}

		


		for (let dateString in this.state.montants) {
		    if (!data.hasOwnProperty(dateString)) {
		        data[dateString] = this.state.montants[dateString];
		    }
		}

		if  ( this.state.continuation ){
			let _prevMonth = ((((12+date.getMonth()-1)%12))+1).toString().padStart(2, "0"); // not date.getMonth()-1 
			let prevMonthYear  = ( date.getMonth() ) > 0 ? parseInt(date.getFullYear()) : parseInt(date.getFullYear())-1;
			let previousMonth = `${prevMonthYear}-${_prevMonth}`;

			data[this.thisMonth] = data[previousMonth];
		}else {
			data[this.thisMonth] = 0;
		}

		if ( sumLastThreeMonths > montantTotal  || isNaN(reste) || reste <0) {
			;
		}else {
			this.setState( () =>{
				return {inputError : ""} ;
			})
			data.invalid = false;
		}


		// Construire un objet contenant toutes les mises à jour à appliquer à this.state.montants
		let updatedMontants = {};

		for (let d in data) {
			if(data[d] ){
				updatedMontants[d] = data[d];
			}
		}
	
		// Mettre à jour l'état une seule fois avec toutes les mises à jour
		this.setState(prevState => ({
		    montants: {
		        ...prevState.montants,
		        ...updatedMontants
		    }
		}));
		
		console.clear();
		
		console.log(this.state.montants);
		this.props.handler (data , this.props.modelName);
	}
			
		
	

	changeMontant = (montant , dateString) =>{
		this.setState( ({montants})=>{
			montants[dateString] = montant;
			return {montants :montants}
		},this.distributeMontants )
		
	}

	changeMontantTotal = (e) =>{
		const montantTotal = parseInt(e.target.value);
		this.setState( ()=>({totalYear : montantTotal}) , this.distributeMontants);
		
	}


	captureContinuation = (value) => {
		this.setState( ()=>{
			return {continuation: JSON.parse(value)}
		},this.distributeMontants);


	}

	render(){
		return <div className="montants-detailles">
			{Object.keys(this.state.montants).slice(0,3).map( (dateString,i)=>(
				<div>
					<label htmlFor={this.props.name+i}>{getMonthText(dateString)}</label>
					<input 
						id={this.props.name+i}
						value={this.state.montants[dateString]}
						placeholder="Ex : 1000"
						onChange= { (e)=> (this.changeMontant(parseInt(e.target.value) , dateString))}
						type="number"/>
					
				</div>
			))}
			<div className="total-input">
				<label htmlForm="total">Total des 12 derniers mois</label>
				<input 
					id="total"
					value={this.state.totalYear}
					placeholder="Ex : 12000"
					onChange= {this.changeMontantTotal}
					onBlur={this.changeMontantTotal}
					type="number"/>

			</div>
			<div className="montant-continuation">
				<RadioBox
					name="continuation"
					options={{
						"Oui" : true, 
						"Non" : false,
					}}
					defaultValue ={this.state.continuation}
					modelName ="continuation"
					handler ={this.captureContinuation}>
						{( this.props.name ===  'pensionAlimentaire')?
							<p>Vous verserez une pension alimentaire en {getMonthText(this.thisMonth)}</p>
						  : <p>Vous percevrez {this.props.single} en {getMonthText(this.thisMonth)}</p>
						}
					</RadioBox>
			</div>
			<FormError errors={[this.state.inputError]} />
		</div>;
	}
}
export {MontantsDetailles};
